var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mx-3" }, [
    _c("div", { staticClass: "bg-white border-radius--light py-2 rounded" }, [
      _vm._m(0),
      _vm.showAssistanceService
        ? _c("div", { staticClass: "d-flex mt-n3 ml-4" }, [
            _c("div", [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Acompañante:")
              ]),
              _c("div", { staticClass: "d-flex align-items-center mt-2" }, [
                _c("em", {
                  staticClass: "fas fa-user-friends color-gray-7 font-13"
                }),
                _c("span", { staticClass: "color-black font-12 ml-2" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.assistanceService.hasCompanion ? "Si" : "No") +
                      " "
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "ml-5" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Millaje:")
              ]),
              _c("div", { staticClass: "d-flex align-items-center mt-2" }, [
                _c("em", { staticClass: "fas fa-car color-gray-7 font-13" }),
                _c("span", { staticClass: "color-black font-12 ml-2" }, [
                  _vm._v(" " + _vm._s(_vm.assistanceService.mileage) + " ")
                ])
              ])
            ]),
            _c("div", { staticClass: "ml-5" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Costo Diario:")
              ]),
              _c("div", { staticClass: "d-flex align-items-center mt-1" }, [
                _vm._m(1),
                _c(
                  "div",
                  { class: _vm.amountClass(_vm.assistanceService.serviceCost) },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.assistanceService.serviceCost) + " "
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "ml-5" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center mt-3" },
                [
                  _vm.showUpdateMillage
                    ? _c(
                        "action-button",
                        {
                          attrs: { i: "fas fa-redo-alt", variant: "success" },
                          on: { click: _vm.updateMillageCompanion }
                        },
                        [_vm._v(" Actualizar Millaje/Acompañante ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row px-3 mt-4 mt-md-0 mt-sm-4" },
        _vm._l(_vm.normalAssistances, function(item, index) {
          return _c(
            "div",
            {
              key: `calendar-row-${index}`,
              staticClass: "col-md-2 col-sm col-6 calendar-card"
            },
            [_c("calendar-card", { attrs: { value: item } })],
            1
          )
        }),
        0
      ),
      _c("div", [
        _c("div", { staticClass: "row mt-4" }, [
          _vm.adjustAssistances.length > 0
            ? _c(
                "div",
                { staticClass: "col-md-12 mb-4 assistence-details-label" },
                [
                  _c("em", {
                    staticClass: "fas fa-info-circle text-orange mr-2"
                  }),
                  _c("span", [_vm._v("Detalles de Ajustes")])
                ]
              )
            : _vm._e()
        ]),
        _vm.adjustAssistances.length > 0
          ? _c("div", { staticClass: "row mb-4 ml-1" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("period-selector", {
                    attrs: {
                      periods: _vm.adjustPeriods,
                      "selected-period": _vm.selectedPeriod
                    },
                    on: { "on-select-period": _vm.onSelectedPeriodHandler }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "row px-3 mt-4 mt-md-0 mt-sm-4" },
          _vm._l(_vm.adjustAssistances, function(item, index) {
            return _c(
              "div",
              {
                key: `calendar-row-${index}`,
                staticClass: "col-md-2 col-sm col-6 calendar-card"
              },
              [
                _c("calendar-card", {
                  staticClass: "calendar-card",
                  attrs: { value: item }
                })
              ],
              1
            )
          }),
          0
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.assistanceSummary.peiAnalysisServiceId ==
                  _vm.serviceTypeEnum.educativo &&
                _vm.assistanceSummary.isManualAssistanceFlag == false,
              expression:
                "\n        assistanceSummary.peiAnalysisServiceId == serviceTypeEnum.educativo &&\n          assistanceSummary.isManualAssistanceFlag == false\n      "
            }
          ],
          staticClass: "row bg-secondary-29 pt-3 mx-n3 rounded"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-9 col-md-3 bg-white d-flex align-items-center p-2 pl-4 mr-3 mb-3 py-3 w-25"
            },
            [
              _c("check-box", {
                staticClass: "w-auto",
                attrs: { disabled: _vm.isAnalized, text: "" },
                model: {
                  value: _vm.isAnalized,
                  callback: function($$v) {
                    _vm.isAnalized = $$v
                  },
                  expression: "isAnalized"
                }
              }),
              _vm._m(2)
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mb-4" }, [
      _c("div", { staticClass: "col-md-6 mb-3 assistence-details-label" }, [
        _c("em", { staticClass: "fas fa-info-circle text-orange mr-2" }),
        _c("span", [_vm._v("Detalles de Asistencia")])
      ]),
      _c("div", { staticClass: "col-md-6 text-right" }, [
        _c(
          "span",
          {
            staticClass:
              "bg-secondary-1 p-2 px-4 badge badge-pill font-weight-bold font-13"
          },
          [_vm._v(" Fórmula de Cálculo: $0.40 x Millas x Acompañante ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "fa-stack fa-1x color-secondary-25 font-11 mr-1" },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fas fa-dollar-sign fa-stack-1x fa-inverse" })
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticClass: "color-gray-7 font-16 font-weight-bold m-0 pt-1" },
      [
        _vm._v(" Marcar record como "),
        _c(
          "span",
          { staticClass: "color-orange font-weight-bold font-italic font-16" },
          [_vm._v(" Analizado ")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }